import React, { Component } from 'react';

import ResearchField from './ResearchField';

class Research extends Component {
    render() {
        return (
            <React.Fragment>
                <div style={horizontalDivider} />
                <div style={researchWrapperStyle}>
                    <div style={researchStyle}>
                        <div style={researchSubStyle}>
                            <h1 style={researchHeaderStyle}>Featured Research</h1>

                            <ResearchField research={this.props.research} />

                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const horizontalDivider = {
    width: '530px',
    height: '2px',
    margin: '10px auto',
    backgroundColor: '#e8e8e8',
}

const researchWrapperStyle = {
    width: '100%',
    padding: '60px 20px 20px 20px',
}

const researchStyle = {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
}

const researchSubStyle = {
    width: '1200px',
    margin: '0px 0px 0px 0px',
    textAlign: 'center',
    order: '3',
}

const researchHeaderStyle = {
    fontFamily: 'Heebo, sans-serif',
    fontSize: '40px',
    fontWeight: '300',
    padding: '10px 20px 40px 19px'
}

export default Research;